const handleCellVideoPlay = (videoContainer) => {
    const video = videoContainer.querySelector('.project-highlight__video');
    const playButton = videoContainer.querySelector('.project-highlight__phone--circle');

    playButton.addEventListener("click", (e) => {
        if (video.classList.contains('paused')) {
            video.classList.remove('paused');
            video.play();
        } else {
            video.classList.add('paused');
            video.pause();
        }
    })
}

export { handleCellVideoPlay };